import React from "react";
import Head from "next/head";
import Footer from "../components/Footer";
import Layout from "../components/Layout";
import Header from "../components/Header";
import HashtagSignShop from "../components/SignShop/Hashtag";
import VendorBar from "../components/VendorBar";

export default function IndexRoute() {
  return (
    <>
        <Head>
            <title>Hashtag Sign Shop - TacBoard</title>
            <meta name="description" content="Access tons of free wedding signs featuring your own hashtag at the TacBoard sign shop." />
            <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Aleo:200,300,400,700|Montserrat:300,400,500,700" />
                <link rel="canonical" href="https://tacboard.com/wedding-sign-shop" />
        </Head>

      <Layout classes={["signshopp layout", "public"]}>
        <Header />
        <HashtagSignShop />
        <VendorBar />
        <Footer />
      </Layout>
    </>
  );
};
